<app-header-dashboard></app-header-dashboard>


<main class="main">

    <div class="dashbox h-100">
        <h2 class="dashbox_title">Commission Transaction</h2>



        <div class="table-responsive">
            <div class="d-flex justify-content-center mb-5" *ngIf="!loader; else tabledata">
                <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
                <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
                <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            </div>

            <ng-template #tabledata>

                <table class="table primary_table">
                    <thead>
                        <tr>
                            <th>Date / Time</th>
                            <th>Coin</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Staked Coins</th>
                            <th>Reward</th>

                            <th>Total Coin</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let txn of transactions | textFilter: 'status':search :'status'">
                            <td>{{ txn.createdAt | date : "medium" }}</td>
                            <td>
                                <span>{{ txn.coin }}</span>
                            </td>
                            <td>
                                <span>{{
                                    txn.bankPaymentType
                                    }}</span>
                            </td>
                            <td>
                                <span>{{
                                    txn.fiatAmount
                                    }}</span>
                            </td>
                            <td>
                                <span>{{
                                    txn.coinValue?.toFixed(2) ?? '0.00'
                                    }}</span>
                            </td>
                            <td>
                                <span>{{ txn.reward?.toFixed(2) ?? '0.00' }}</span>
                            </td>

                            <td>
                                <span>{{
                                    txn.totalCoinvalue
                                    }}</span>
                            </td>
                            <td
                                [ngClass]="{'green_txt': txn.status === 'approved', 'red_txt': txn.status === 'rejected'}">
                                {{txn.status | titlecase}}
                            </td>
                            <td>
                                <button
                                    *ngIf="txn.status !== 'rejected' && txn.status !== 'processing' && txn.status !== 'pending' && txn.withdrawStatus !== 'requested' && txn.withdrawStatus !== 'approved' "
                                    type="button" class="withdraw_btn cursor-pointer"
                                    [disabled]="!txn.isWithdrawEnabled"
                                    [ngClass]="{ 'disabled-btn': !txn.isWithdrawEnabled }"
                                    (click)="sendWithdrawRequest(txn._id)">
                                    Withdraw
                                </button>
                                <span *ngIf="txn.withdrawStatus === 'requested' || txn.withdrawStatus === 'approved'">
                                    {{ txn.withdrawStatus === 'requested' ? 'Requested' : 'Approved' }}
                                </span>

                                <span *ngIf="txn.status !== 'approved' && txn.withdrawStatus !== 'requested'">--</span>
                            </td>

                        </tr>
                        <tr *ngIf="transactions && transactions.length == 0">
                            <td colspan="4">
                                <div class="text-center mt-3">
                                    <img src="assets/images/no_records_found.png" alt="No Records" img="img-fluid" />
                                    <p>No Records Found !</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-template>

        </div>

        <!-- <div class="last_trans_list">
          <div class="last_trans_list_row" *ngFor="let txn of transactions">
            <div>
              <h2>{{ txn.actualAmount + " " + txn.coin }}</h2>
              <h3 class="green_txt">
                {{ txn.paymentType.replace("_", " ") | titlecase }}
              </h3>
            </div>
            <h5>{{ txn.createdAt | date : "medium" }}</h5>
          </div>
          <div *ngIf="transactions && transactions.length == 0">
            <div class="text-center mt-3">
              <img
                src="assets/images/no_records_found.png"
                alt="No Records"
                img="img-fluid"
              />
              <p>No Records Found !</p>
            </div>
          </div>
        </div> -->
    </div>



</main>
<main class="main">

    <div class="dashbox h-100">
        <h2 class="dashbox_title">Earn Track Transaction</h2>



        <div class="table-responsive">
            <div class="d-flex justify-content-center mb-5" *ngIf="!loader; else tabledatas">
                <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
                <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
                <span class="text-primary spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            </div>

            <ng-template #tabledatas>

                <table class="table primary_table">
                    <thead>
                        <tr>
                            <th>Date / Time</th>
                            <th>Coin</th>
                            <th>Type</th>
                            <th>Amount</th>
                            
                           

                            <th>Duration</th>
                            <th>Remaing Days</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let txns of tranxdetails | textFilter: 'status':search :'status'">
                            <td>{{ txns.createdAt | date : "medium" }}</td>
                            <td>
                                <span>{{ txns.coin }}</span>
                            </td>
                            <td>
                                <span>{{
                                    txns.stakeOrHold
                                    }}</span>
                            </td>
                            <td>
                                <span>{{
                                    txns.amount
                                    }}</span>
                            </td>
                           
                            
                           
                            <td>
                                <span>{{txns.duration}}</span>
                            </td>
                            <td>
                                <span>{{txns.remainingDays}}</span>
                            </td>
                            <td>
                                <span>{{txns.status}}</span>
                            </td>

                        </tr>
                        <tr *ngIf="transactions && transactions.length == 0">
                            <td colspan="4">
                                <div class="text-center mt-3">
                                    <img src="assets/images/no_records_found.png" alt="No Records" img="img-fluid" />
                                    <p>No Records Found !</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-template>

        </div>

        <!-- <div class="last_trans_list">
          <div class="last_trans_list_row" *ngFor="let txn of transactions">
            <div>
              <h2>{{ txn.actualAmount + " " + txn.coin }}</h2>
              <h3 class="green_txt">
                {{ txn.paymentType.replace("_", " ") | titlecase }}
              </h3>
            </div>
            <h5>{{ txn.createdAt | date : "medium" }}</h5>
          </div>
          <div *ngIf="transactions && transactions.length == 0">
            <div class="text-center mt-3">
              <img
                src="assets/images/no_records_found.png"
                alt="No Records"
                img="img-fluid"
              />
              <p>No Records Found !</p>
            </div>
          </div>
        </div> -->
    </div>



</main>